import { i18nKeys } from '@/src/utils/i18n.utils';
import { aboutAwsJamVideo } from '@/src/utils/jam-urls';
import { Box, Grid, GridProps, Icon } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';
import IntroVideo from '../IntroVideo/IntroVideo';
import './MeetAwsJam.scss';

const MeetAwsJam = () => {
  const { t } = useTranslation();
  const colspan: GridProps.BreakpointMapping = { xl: 6, l: 6, m: 6, s: 6, xs: 12, xxs: 12 };
  return (
    <div className="meet-aws-jam-container">
      <Box padding={{ top: 'xxxl', bottom: 'xxxl' }}>
        <Box padding={{ top: 'l', bottom: 'l' }}>
          <Grid gridDefinition={[{ colspan }, { colspan }]}>
            <div style={{ flex: 1 }}>
              <Box variant="h2" padding={{ top: 'xxxl', bottom: 'xxxl' }} fontSize="display-l">
                {t(i18nKeys.catalog.meetAwsTeam.title)}
              </Box>
              <Box variant="p">
                {t(i18nKeys.catalog.meetAwsTeam.description)}{' '}
                <a
                  href={aboutAwsJamVideo}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px',
                    whiteSpace: 'nowrap',
                    color: '#539fe5',
                    textDecoration: 'none',
                    fontSize: '14px',
                    verticalAlign: 'middle',
                  }}
                >
                  <Icon name="caret-right-filled" size="small" />
                  {t(i18nKeys.catalog.meetAwsTeam.videoLink)}
                </a>
              </Box>
            </div>
            <div>
              <IntroVideo />
            </div>
          </Grid>
        </Box>
      </Box>
    </div>
  );
};

export default MeetAwsJam;
